/// <amd-module name="Artifacts/Npm/commands/PermanentDelete" />

import { NpmActions } from "Artifacts/Npm/redux";
import { getPermanentDeleteCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createPermanentDeleteCommand = getPermanentDeleteCommandCreator(
  NpmActions.permanentDelete,
);
